/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.x.ai.integration.rpc.AppSettingsRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type ApiKeyUpdateRequest = { apiKey: string };

export type ApiKeyUpdateResponse = {};

export type AppInstallRequest = { apiKey: string };

export type AppInstallResponse = { responseField: string };

export type XAiAppError = {
  chirpErrorMessage: Default<string>;
  type: ErrorType;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ErrorType = 'INVALID_API_KEY' | unhandledEnumCase;

export type InstallRequestType = Requestify<AppInstallRequest>;
export type InstallResponseType = AppInstallResponse;
export type InstallErrorType = XAiAppError & HubspotMetadata;
export const installRpc: ChirpAvroRpcDetails<
  InstallRequestType,
  InstallResponseType,
  InstallErrorType,
  false
> = {
  serviceName: 'com.hubspot.x.ai.integration.rpc.AppSettingsRpc',
  rpcName: 'install',
  auth: 'app',
  fingerprint: 'zAyifeVsX_SOLisWpuNhsX7dq3pjbAQ3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpsertApiKeyRequestType = Requestify<ApiKeyUpdateRequest>;
export type UpsertApiKeyResponseType = ApiKeyUpdateResponse;
export type UpsertApiKeyErrorType = XAiAppError & HubspotMetadata;
export const upsertApiKeyRpc: ChirpAvroRpcDetails<
  UpsertApiKeyRequestType,
  UpsertApiKeyResponseType,
  UpsertApiKeyErrorType,
  false
> = {
  serviceName: 'com.hubspot.x.ai.integration.rpc.AppSettingsRpc',
  rpcName: 'upsertApiKey',
  auth: 'app',
  fingerprint: '5bBMaH2A99Qs9ON1fOU11X7dq3pjbAQ3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
